// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\OrgProfile\OrgProfileViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { DefaultImage, DefaultImageData, DefaultImageOptions } from 'data/models/DefaultImage';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { OrgProfileResponseRef as _OrgProfileResponseRef, OrgProfileResponseRefData as _OrgProfileResponseRefData, OrgProfileResponseRefOptions as _OrgProfileResponseRefOptions } from 'data/models/OrgProfileResponse';
import { PierGroup, PierGroupData, PierGroupOptions } from 'data/models/PierGroup';
import { Port, PortData, PortOptions } from 'data/models/Port';

// OrgProfileResponseData is the class that OrgProfileResponse serializes to/from
export interface OrgProfileResponseData {
    OrganizationId : number;
	
    Organization : OrganizationData | null;
    PierGroups : PierGroupData[] | null;
    Ports : PortData[] | null;
	
    BookingRate : number | null;
    CanAddBerth : boolean;
    CanEdit : boolean;
    CanManageBerths : boolean;
    CanManageUsers : boolean;
    Ref : _OrgProfileResponseRefData;
}

// OrgProfileResponseOptions is the class which may be passed to the OrgProfileResponse constructor to define optional initial data values
export interface OrgProfileResponseOptions {
    OrganizationId : number;
	
    Organization? : OrganizationOptions | null;
    PierGroups? : PierGroupOptions[] | null;
    Ports? : PortOptions[] | null;
	
    BookingRate? : number | null;
    CanAddBerth? : boolean;
    CanEdit? : boolean;
    CanManageBerths? : boolean;
    CanManageUsers? : boolean;
    Ref? : _OrgProfileResponseRefOptions;
}

export class OrgProfileResponse {
    public OrganizationId : DataSignal<number>;
	
    public Organization : DataSignal<Organization | null>;
    public PierGroups : SDataArray<PierGroup>;
    public Ports : SDataArray<Port>;
	
    public BookingRate : DataSignal<number | null>;
    public CanAddBerth : DataSignal<boolean>;
    public CanEdit : DataSignal<boolean>;
    public CanManageBerths : DataSignal<boolean>;
    public CanManageUsers : DataSignal<boolean>;
    public Ref : _OrgProfileResponseRef;

    constructor();
    constructor(data : OrgProfileResponseOptions);
    constructor(data: OrgProfileResponseOptions | null = null) {
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
	    
        this.Organization = S.value<Organization | null>(null);
        this.PierGroups = SArray<PierGroup>([]);
        this.Ports = SArray<Port>([]);
	    
        this.BookingRate = jsonableObservable(S.value<number | null>(data && data.BookingRate !== undefined ? data.BookingRate : null));
        this.CanAddBerth = jsonableObservable(S.value<boolean>(data && data.CanAddBerth !== undefined ? data.CanAddBerth : false));
        this.CanEdit = jsonableObservable(S.value<boolean>(data && data.CanEdit !== undefined ? data.CanEdit : false));
        this.CanManageBerths = jsonableObservable(S.value<boolean>(data && data.CanManageBerths !== undefined ? data.CanManageBerths : false));
        this.CanManageUsers = jsonableObservable(S.value<boolean>(data && data.CanManageUsers !== undefined ? data.CanManageUsers : false));
        this.Ref = data && data.Ref !== undefined ? new _OrgProfileResponseRef(data.Ref) : new _OrgProfileResponseRef();
    }

    static key(obj : OrgProfileResponse) {
        return obj.OrganizationId();
    }
    
    static dataKey(obj : OrgProfileResponseOptions) {
        return obj.OrganizationId;
    }

    static update(obj : OrgProfileResponse, data : OrgProfileResponseOptions) {
        S.freeze(() => {
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
	        
            if (data.BookingRate !== undefined) obj.BookingRate(data.BookingRate);
            if (data.CanAddBerth !== undefined) obj.CanAddBerth(data.CanAddBerth);
            if (data.CanEdit !== undefined) obj.CanEdit(data.CanEdit);
            if (data.CanManageBerths !== undefined) obj.CanManageBerths(data.CanManageBerths);
            if (data.CanManageUsers !== undefined) obj.CanManageUsers(data.CanManageUsers);
            if (data.Ref !== undefined) _OrgProfileResponseRef.update(obj.Ref, data.Ref);
        });
    }
}

// OrgProfileResponseRefData is the class that OrgProfileResponseRef serializes to/from
export interface OrgProfileResponseRefData {
	
    DefaultImages : DefaultImageData[] | null;
	
    AllowedImageUploadExtensions : string[];
    MaximumImageUploadFileSize : number;
    MinimumImageUploadImageSize : number;
}

// OrgProfileResponseRefOptions is the class which may be passed to the OrgProfileResponseRef constructor to define optional initial data values
export interface OrgProfileResponseRefOptions {
	
    DefaultImages? : DefaultImageOptions[] | null;
	
    AllowedImageUploadExtensions? : string[];
    MaximumImageUploadFileSize? : number;
    MinimumImageUploadImageSize? : number;
}

export class OrgProfileResponseRef {
	
    public DefaultImages : SDataArray<DefaultImage>;
	
    public AllowedImageUploadExtensions : SDataArray<string>;
    public MaximumImageUploadFileSize : DataSignal<number>;
    public MinimumImageUploadImageSize : DataSignal<number>;

    constructor();
    constructor(data : OrgProfileResponseRefOptions);
    constructor(data: OrgProfileResponseRefOptions | null = null) {
	    
        this.DefaultImages = SArray<DefaultImage>([]);
	    
        this.AllowedImageUploadExtensions = jsonableObservable(SArray<string>(data && data.AllowedImageUploadExtensions !== undefined ? data.AllowedImageUploadExtensions : []));
        this.MaximumImageUploadFileSize = jsonableObservable(S.value<number>(data && data.MaximumImageUploadFileSize !== undefined ? data.MaximumImageUploadFileSize : 0));
        this.MinimumImageUploadImageSize = jsonableObservable(S.value<number>(data && data.MinimumImageUploadImageSize !== undefined ? data.MinimumImageUploadImageSize : 0));
    }

    static key(obj : OrgProfileResponseRef) {
        return ;
    }
    
    static dataKey(obj : OrgProfileResponseRefOptions) {
        return ;
    }

    static update(obj : OrgProfileResponseRef, data : OrgProfileResponseRefOptions) {
        S.freeze(() => {
	        
	        
            if (data.AllowedImageUploadExtensions !== undefined) obj.AllowedImageUploadExtensions(data.AllowedImageUploadExtensions);
            if (data.MaximumImageUploadFileSize !== undefined) obj.MaximumImageUploadFileSize(data.MaximumImageUploadFileSize);
            if (data.MinimumImageUploadImageSize !== undefined) obj.MinimumImageUploadImageSize(data.MinimumImageUploadImageSize);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/OrgProfileResponse.ts